(function () {
    'use strict';

    angular
        .module('bunge')
        .constant('SIDEBAROPTS', [
             'administracao',
             'fornecedor'
        ]);
})();